import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class CardTitle extends Component {
  render() {
    const { content } = this.props
    return <h6 className="text-secondary">{content}</h6>
  }
}

CardTitle.propTypes = {
  content: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/ui/typography/CardTitle.js